import styled from 'styled-components';
import { Flex } from './Flex';

export const Section = styled(Flex)`
  align-items: flex-start;
  justify-content: flex-start;
  flex: 0 1 auto;
  margin: 12px;
  padding: 12px;
  border: 1px solid #333;
  color: #aaa;
  h2 {
    margin: 0;
    margin-bottom: 8px;
    font-size: 1.3em;
  }
  h3 {
    margin: 0;
    font-size: 1.1em;
  }
`;
